import React, { Fragment } from 'react'
import Img from 'gatsby-image'
import { useStaticQuery, graphql } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import {
  SectionContainer,
  SectionTitle,
  SectionDivider,
  SocialShareIcons,
} from '../../../components/_common'
import { Grid, Typography } from '@material-ui/core'

import useStyles from './styles'
import { lightTheme } from '../../../App.theme'

const getData = graphql`
  query {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`

const BlogPost = ({ data }) => {
  const {
    wrapper,
    imgContainer,
    image,
    infoClass,
    infoWrapper,
    content,
  } = useStyles()

  const { slug, titulo, autor, fechaDeCreacion, imagen, contenido } = data.blog

  const { site } = useStaticQuery(getData)
  const { siteUrl } = site.siteMetadata

  const options = {
    renderText: (text) =>
      text.split('\n').flatMap((text, i) => [i > 0 && <br key={i} />, text]),
    renderNode: {
      'embedded-asset-block': (node) => {
        return (
          <div>
            {node.data.target.fields && (
              <img
                width="80%"
                src={node.data.target.fields.file['en-US'].url}
                alt={titulo}
              />
            )}
          </div>
        )
      },
    },
  }

  return (
    <Fragment>
      <SectionContainer>
        <SectionDivider
          title={titulo}
          color={lightTheme.palette.extras.strongTeal}
        />

        <Grid container className={infoWrapper}>
          <Grid item xs className={infoClass}>
            <Typography noWrap component="span">
              {autor}
            </Typography>
          </Grid>
          <Grid item xs className={infoClass}>
            <Typography noWrap component="span">
              {fechaDeCreacion}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={wrapper}>
          <Grid item container className={imgContainer}>
            <Img className={image} fluid={imagen.fluid} alt={slug + 'imagen'} />
          </Grid>
          <SectionTitle title={titulo} />
          <Grid item container className={content}>
            <article>
              {documentToReactComponents(contenido.json, options)}
            </article>
          </Grid>
        </Grid>
        <SocialShareIcons
          text="Si te gustó nuestro contenido, comparte en redes."
          shareTitle={`${titulo} por: ${autor}`}
          url={`${siteUrl}/blog/${slug}`}
        />
      </SectionContainer>
    </Fragment>
  )
}

export default BlogPost
